import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';

import { Row, Col, Card, CardBody, Table, Button, Input, Spinner, Alert } from 'reactstrap';

import { connect } from 'react-redux';

import {
  getNewOutreachTooltips,
  updateNewOutreachTooltip,
} from '../../../../../actions/contentManagement';

class NewOutreachTooltips extends Component {
  static propTypes = {
    user: PropTypes.shape(),
    dashboardTooltips: PropTypes.shape(),
    fetchTooltips: PropTypes.func.isRequired,
    updateTooltip: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: {},
    dashboardTooltips: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      success: null,
      tooltips: {},
      subTabs: [],
      NewOutreachSubTab: {},
    };
  }

  componentDidMount() {
    const { fetchTooltips, admin, user, isLoggedIn, history } = this.props;

    fetchTooltips().then((res) => {
      console.log('fetchTooltips', { res });
      if (res && res.tooltips) {
        let tooltips = {};
        let subTabs = [{ id: "newOutreach", name: "New Outreach" }];
        let newOutreachSubTab = {};

        Object.keys(res.tooltips).map((key) => {
          if (res.tooltips[key].subTab && res.tooltips[key].subTab === 'newOutreach') {
            newOutreachSubTab[key] = res.tooltips[key];
          } else {
            tooltips[key] = res.tooltips[key];
          }
          return null;
        });
        this.setState({ tooltips, subTabs, newOutreachSubTab });
      }
    });
  }

  openSubtab = (id) => {
    this.setState({ openedTab: id });
  }

  handleChange = (e, type) => {
    e.preventDefault();

    console.log('target', { target: e.target });
    if (e.target) {
      const { name, value } = e.target;
      console.log(e.target.name);

      if (type === 'newOutreach') {
        this.setState((prevState) => ({
          newOutreachSubTab: {
            ...prevState.newOutreachSubTab,
            [name]: {
              ...prevState.newOutreachSubTab[name],
              value,
            },
          },
          error: null,
          success: null,
        }));
      } else {
        this.setState((prevState) => ({
          tooltips: {
            ...prevState.tooltips,
            [name]: {
              ...prevState.tooltips[name],
              value,
            },
          },
          error: null,
          success: null,
        }));
      }
    }
  };

  updateTooltips = () => {
    const { updateTooltips, user } = this.props;
    const { tooltips, newOutreachSubTab } = this.state;

    let adminName;

    if (user.name || (user.firstName && user.lastName)) {
      adminName = user.name ? user.name : `${user.firstName} ${user.lastName}`;
    }

    this.setState({ saveSpinner: true });

    updateTooltips({ ...newOutreachSubTab, ...tooltips }, adminName).then((res) => {
      if (res === 'success') {
        this.setState({ success: true, error: null, saveSpinner: null });
      } else if (res === 'error') {
        this.setState({ success: null, error: true, saveSpinner: null });
      }
    });
  }

  render() {
    const { user } = this.props;
    const {
      error,
      success,
      name,
      tooltips,
      subTabs,
      newOutreachSubTab,
      openedTab,
      saveSpinner,
    } = this.state;

    console.log('NewOutreachSubTab', tooltips, subTabs, newOutreachSubTab);

    return (
      <div>
        {(!!success) && <Alert color="success">Update successful</Alert>}
        {(!!error) && <Alert color="danger">Update failed, please try again</Alert>}
        {tooltips ? Object.keys(tooltips).sort((a, b) => (tooltips[a].index - tooltips[b].index)).map((key) => (
          <Row>
            <Col sm="6">
              {tooltips[key].name}
            </Col>
            <Col sm="6">
              <Input
                type="textarea"
                name={key}
                id={`data-${key}`}
                value={tooltips[key].value}
                onChange={(e) => this.handleChange(e, null)}
              />
            </Col>
          </Row>
        )) : (null)}

        <Button onClick={this.updateTooltips}>
          Save
          {saveSpinner ? (
            <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
          ) : (null)}
        </Button>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.userData || {},
  newOutreachTooltips: state.contentManagement.newOutreachTooltips || {},
});

const mapDispatchToProps = {
  fetchTooltips: getNewOutreachTooltips,
  updateTooltips: updateNewOutreachTooltip,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewOutreachTooltips));
